const disclaimer = {
  en: `
  <span>
    <section id='disclaimer-container'>
      <h1 className='title'>IPC Disclaimer</h1>
      <p>
        Disclaimer of Warranties. You acknowledge and agree that this site is provided on an “as is” and “as available” basis. None of Intermediary Platform Company Ltd. its affiliates, subsidiaries or their respective officers, directors, employees or agents (collectively the “Intermediary Platform parties”) guaranteed the timeliness, accuracy, reliability, completeness, or usefulness of any of the site. None of the Intermediary Platform parties warrant that this site or downloads will meet your needs or expectations, or be uninterrupted, secure or error free or that this site, its server or any files available for downloading through this site are free to computer viruses or other harmful elements. The Intermediary Platform parties have no responsibility for viruses or any other damage that may be caused to you as a result of using this site. Periods of volatile or unusual market activity, in particular, may affect systems availability or response time.
      </p>
      <p>
        Any directors or employees of Intermediary Platform parties, shall not be liable for (whether in tort or contract or otherwise) any damages arising from any person reliance on this information and shall not be liable for any errors or omissions (including but not limited to errors or omissions made by third party sources) in this information. The information provided herein is subject to change without further notice.
      </p>
    </section>
  </span>
  `,
  zh: `
  <span>
    <section id='disclaimer-container'>
      <h1 className='title'>免責聲明</h1>
      <p>免責聲明的保證。閣下明白及同意本網站是以現時模式提供服務。中介平台服務有限公司及其附屬與子公司或有關職員，董事，僱員或代表〔統稱「中介平台服務一方」〕並沒有保證本內容的合時性、正確性、可靠性、原整性及可用性。中介平台服務一方亦沒有保證本網站或其所下載的物料能符合閣下要求及期望，或以沒有干擾的情況下得到或沒有任何錯誤。亦沒有保證經本網站下載的檔案是沒有電腦病毒或其他有害物料。就閣下使用本網站而因電腦病毒或其他情況下受損失，中介平台服務一方並不負責。如有不尋常市場活動或波幅時段，亦會影響系統操作及回應的時間。</p>
      <p>中介平台服務一方之任何董事或僱員並不對任何人士因倚賴任何此網頁所提供之資料或建議所引起之損失而負上責任（不論是民事侵權行為責任或合約責任或其他方面）；亦不因任何所提供之資料或建議的不確或遺漏而負上責任（包括但並不限於由其他第三者資料造成之不確或遺漏）。該等資料或建議可隨時更改，而無須事前另行通知。</p>
      <p>對第三者內容，轉介或與第三者網頁連繫並不附上責任。本網站會因資訊或教育目的，或為閣下提供便利，向閣下提供轉介資料，第三者內容或與有關監管機構，非牟利組織，或其他第三者公司及其網站作出聯繫，亦包括與中介平台服務一方有關係的公司。經本網站所得的部分產品、服務、內容包括廣告，工具及資料可由其他非與中介平台服務一方連繫的公司提供（第三者內容）及其來源已清楚認證。在某些情況下，第三者內容可在中介平台服務一方網站出現或經其他連繫往第三者網站。在第三者內容的情況下，可有更多限制其使用用途。閣下應小心細閱該限制，因為該限制可會被中介平台服務一方所限制的更嚴謹。第三者內容提供人有權保留權利更改如何使用其資料的限制，而無須事先通知。根據我們網站的使用條款，在限制更改後使用本網站即等同閣下同意有關更改。</p>
      <p>本網站所揭露之所有資訊以及相關資料，不應視為任何要約或邀請，亦不構成任何法律上或財務上之建議。本網站並非以任何金融理財產品未獲核准或註冊以供銷售的國家或地區之居民為對象。本網站之所有資訊，包括所連結或所揭露之資料以及資料來源，本網站將儘可能求其可靠與正確，但對其可靠與正確性不負保證責任。本網站以及中介平台服務一方之任何主管人員、董事、以及員工對其所在資料或任何建議，勿須承擔責任，且該等資料或建議亦可隨時更改，勿須事先發出通知。本網站所揭露之金融商品資訊以及相關邀約僅適用於法律核准之國家或地區，並不適用於法律未核准或該商品未註冊之國家或地區。</p>
      <p>本網站資訊僅供境外及香港居民使用。非香港居民在使用此網頁前，須注意及遵守所屬司法管轄區之所有適用法律及規例。投資附帶風險。過往表現未必可作日後業績之準則。投資者須注意此刊載之資料並非已列出任何於網頁內所提及之金融產品〔包括保險及投資產品〕所有的有關風險及其他重要事項。如投資者對此所載之資料有任何疑問或查詢詳情，請參閱有關基金章程，或向專業顧問索取意見。</p>
    </section>
  </span>
  `,
  ja: '',
  kr: '',
};

const privacy = {
  en: `
  <span>
    <section id="privacy-container" class="featherlight-inner">
      <h1 class="title">Privacy Policy</h1>
      <ul>
        <li> Intermediary Platform Company ("We") will only collect your personal information that we believe to be relevant and required to understand your financial needs and to conduct our business.</li>
        <li> We may pass your personal information to other companies or agents or third party companies in providing our services to you.</li>
        <li> We may require to disclose your personal information to judicial bodies or our regulators under proper authority.</li>
        <li> We shall at all times observe the Personal Data (Privacy) Ordinance; the Ordinance of the Hong Kong SAR in collecting, maintaining and using the personal data of customers. </li>
      </ul>
    </section>
  </span>
  `,
  zh: `
  <span>
    <section id="privacy-container" class="featherlight-inner">
      <h1 class="title">隱私權政策</h1>
      <ul>
        <li> 中介平台服務有限公司 (「本公司」) 向閣下所收集的個人資料，目的是幫助本公司了解閣下的財務需要及向閣下提供服務。</li>
        <li> 為了向閣下提供服務，本公司會將閣下的個人資料提供給關聯公司、代理人或第三方公司使用。</li>
        <li> 在正確授權情況下，本公司有可能將閣下的個人資料披露給相關的司法單位或監管機構。</li>
        <li> 在收集、保管及運用客戶個人資料時，本公司皆會遵守香港特別行政區發怖之個人資料私隱條例。</li>
      </ul>
    </section>
  </span>
  `,
  ja: '',
  kr: '',
};

export {disclaimer, privacy};
